// Test IDs for the auth feature (login, register, WhatsApp OTP, logout).
// Keys are camelCase, values are kebab-case shaped as `<feature>-<element>`.

export const LOGIN = {
  emailInput: 'login-email-input',
  passwordInput: 'login-password-input',
  submitButton: 'login-submit-button',
  forgotPasswordLink: 'login-forgot-password-link',
  registerLink: 'login-register-link',
  whatsappToggle: 'login-whatsapp-toggle',
  backToPassword: 'login-back-to-password',
};

export const REGISTER = {
  nameInput: 'register-name-input',
  whatsappInput: 'register-whatsapp-input',
  emailInput: 'register-email-input',
  passwordInput: 'register-password-input',
  passwordConfirmInput: 'register-password-confirm-input',
  consentCheckbox: 'register-consent-checkbox',
  submitButton: 'register-submit-button',
  loginLink: 'register-login-link',
};

export const WHATSAPP_OTP = {
  panel: 'whatsapp-otp-panel',
  phoneInput: 'whatsapp-otp-phone-input',
  sendButton: 'whatsapp-otp-send-button',
  codeInput: 'whatsapp-otp-code-input',
  verifyButton: 'whatsapp-otp-verify-button',
  notice: 'whatsapp-otp-notice',
};

export const LOGOUT = {
  button: 'logout-button',
};
